<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-row class="mb-2">
            <b-col md="3" class="mb-1 mb-md-0">
                <b-card no-body class="mb-0">
                    <v-select v-model="parameters.storeId" dir="rtl" :options="listStores" :reduce="(value) => value.id"
                        autocomplete="off" placeholder="مجموعه"
                        :get-option-label="(option) => option.name_Fa ? option.name_En + ' - ' + option.name_Fa : option.name_En"
                        :clearable="false">
                        <template #option="{ name_En, name_Fa }">
                            {{ name_En }} <span v-if="name_Fa">- {{ name_Fa }}</span>
                        </template>
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-card>
            </b-col>
            <b-col md="3" class="mb-1 mb-md-0">
                <b-card no-body class="mb-0">
                    <v-select v-model="parameters.status" dir="rtl" :options="paymentStatus" autocomplete="off"
                        :reduce="(value) => value.id" placeholder="وضعیت پرداخت" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-card>
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-form-input v-model="parameters.transactionCode" dir="ltr" id="transactionCodeId" class="text-center"
                    autocomplete="off" name="transactionCodeId" placeholder="شماره تراکنش بانک" />
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-form-input v-model="parameters.storeOrderNumber" dir="ltr" id="storeOrderNumberId"
                    class="text-center" autocomplete="off" name="storeOrderNumberId" placeholder="شماره فاکتور" />
            </b-col>
            <b-col md="2" class="mb-1 mb-md-0">
                <b-button @click="orderOnlinePayments" variant="info" class="w-100">جستجو</b-button>
            </b-col>
        </b-row>
        <b-card v-if="orderList.length" class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="orderList" :fields="fields" class="mb-0" striped>
                    <template #cell(status)="data">
                        <b-badge :variant="payment_StatusVariant(data.item.status)" pill>
                            {{ payment_Status(data.item.status) }}
                        </b-badge>
                    </template>
                    <template #cell(payableAmount)="data">
                        {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-card v-else class="text-center pt-5 pb-4">
            موردی وجود ندارد
        </b-card>
        <b-pagination align="center" @input="orderOnlinePayments" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BFormInput, BSpinner, BBadge } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BSpinner,
        BFormInput,
        BBadge,
        vSelect
    },
    computed: {
        payment_Status() {
            return (status) => {
                if (status == 0) {
                    return 'در انتظار پرداخت'
                }
                if (status == 1) {
                    return 'پرداخت شده'
                }
                if (status == 2) {
                    return 'پرداخت نشده'
                }
            }
        },
        payment_StatusVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-warning'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-danger'
                }
            }
        },
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            orderList: [],
            paymentStatus: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'در انتظار پرداخت' },
                { id: 1, name: 'پرداخت شده' },
                { id: 2, name: 'پرداخت نشده' },
            ],
            fields: [
                {
                    key: 'storeName',
                    label: 'شناسه مجموعه',
                },
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'bankTransactionCode',
                    label: 'شماره تراکنش بانک',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                storeId: null,
                storeOrderNumber: null,
                transactionCode: null,
                status: null,
            },
            parametersStores: {
                pageIndex: 1,
                pageSize: 90,
            },
            listStores: []
        }
    },
    methods: {
        orderOnlinePayments() {
            this.loading = true
            adminService.onlinePayments(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.orderList = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
        getListStores() {
            adminService.getListStores(this.parametersStores).then(({ data }) => {
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.name_En) {
                            this.listStores.push(obj)
                        }
                    });
                }
                this.orderOnlinePayments()
            })
        },
    },
    mounted() {
        this.getListStores()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>